import { Link } from "react-router-dom"


export const Footer = () => {
  return (
    <footer>
      <p>
        @ 2023 <Link to="/">Article Blog.</Link> All Rights Reserved.
      </p>
    </footer>
  )
}
